import { ArrowLeft, ShieldAlert } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface AccessDeniedProps {
  /**
   * Friendly section name shown in the heading and body copy. Defaults to
   * "this section" when not supplied.
   */
  sectionName?: string;
  /**
   * Route to navigate back to when the user clicks the CTA. Defaults to
   * `/analytics` — the post-auth landing page.
   */
  backTo?: string;
  /** CTA label override. */
  backLabel?: string;
}

/**
 * Renders inside the protected route as the gated fallback. The server still
 * returns 403 on every gated endpoint — this is UI-only.
 */
export const AccessDenied: React.FC<AccessDeniedProps> = ({
  sectionName = 'this section',
  backTo = '/analytics',
  backLabel = 'Back to Analytics',
}) => {
  const navigate = useNavigate();
  return (
    <div className="reports-access-denied" role="alert">
      <div className="reports-access-denied__icon" aria-hidden="true">
        <ShieldAlert className="w-6 h-6" />
      </div>
      <h1>You don't have access to {sectionName}</h1>
      <p>
        This area is available to organisation Owners and Administrators. Ask your org admin to
        request access.
      </p>
      <button type="button" className="reports-access-denied__cta" onClick={() => navigate(backTo)}>
        <ArrowLeft className="w-4 h-4" aria-hidden="true" />
        <span>{backLabel}</span>
      </button>
    </div>
  );
};
